import { Salutation } from '../../constants'

// Ref: https://github.com/Audibene-GMBH/ta.customer-service/blob/master/internal/model/canonical/canonical-to-domain-salutation.go#L18
const salutationToDisplayText: Record<keyof typeof Salutation, string> = {
  [Salutation.DOCTOR]: 'Dr.',
  [Salutation.DOCTOR_MEDICAL]: 'Dr.',
  [Salutation.MISS]: 'Miss',
  [Salutation.MISSES]: 'Mrs.',
  [Salutation.MISTER]: 'Mr.',
  [Salutation.PROFESSOR]: 'Prof.',
  [Salutation.PROFESSOR_DOCTOR]: 'Prof. Dr.',
  [Salutation.PROFESSOR_DOCTOR_DOCTOR]: 'Prof. Dr. Dr.',
}

export { salutationToDisplayText }
